/** Dual UX copy — French (default) & English */

export const LOCALES = Object.freeze(["fr", "en"]);
export const DEFAULT_LOCALE = "fr";

export const messages = {
  fr: {
    "meta.title": "Olé Olé",
    "meta.description":
      "Olé Olé — présence territoriale en Corse. Service d'intérêt général C.O.R.S.I.C.A., agent John.",
    "brand.subtitle": "Présence territoriale · C.O.R.S.I.C.A. · John",
    "proto.banner":
      "Early proto — version exploratoire. Données contribuées non représentatives · pas de messagerie · pas de profils type dating.",
    "proto.localMode": "mode local (navigateur)",
    "time.now": "Maintenant",
    "time.tonight": "Ce soir",
    "time.tomorrow": "Demain",
    "time.aria": "Fenêtre temporelle",
    "nav.contribute": "Contribuer",
    "nav.mode": "Auto",
    "nav.john": "John",
    "nav.info": "À propos",
    "nav.panelsAria": "Panneaux",
    "map.aria": "Carte des présences",
    "map.presenceCount": "{count} présence(s) déclarée(s)",
    "map.aggregateNote": "Agrégat contribué — non représentatif",
    "map.intents": "Intentions (agrégat):",
    "map.intent.discovery": "découverte",
    "map.intent.social": "social",
    "map.intent.oleole": "olé olé",
    "map.noPresence": "Aucune présence contribuée sur cette fenêtre",
    "map.sources": "Sources: {list}",
    "context.title": "Que se passe-t-il ici ?",
    "context.chooseHint":
      "Choisissez un lieu ou utilisez votre position pour un contexte immédiat.",
    "context.useLocation": "Utiliser ma position",
    "context.choosePlace": "Choisir un lieu",
    "context.choosePlaceholder": "Choisir…",
    "context.privacy":
      "Cette demande reste temporaire : elle ne publie aucune présence et votre position est arrondie avant la requête.",
    "context.loading": "Chargement du contexte territorial…",
    "context.unavailable": "Le contexte atmosphérique n’est pas disponible pour le moment.",
    "context.geoUnavailable": "La géolocalisation n’est pas disponible sur cet appareil.",
    "context.geoDenied": "Position non utilisée. Vous pouvez choisir un lieu à la place.",
    "context.outsideCorsica": "Olé Olé propose ce contexte pour la Corse uniquement.",
    "context.nearYou": "Autour de vous (approximatif)",
    "context.atmosphere": "Atmosphère",
    "context.mobility": "Mobilité",
    "context.energy": "Énergie / EDF",
    "context.charging": "Recharge / IRVE",
    "context.events": "Événements",
    "context.unknown": "Inconnu",
    "context.feelsLike": "Ressenti {temp}°C · vent {wind} km/h",
    "context.reason.no_fresh_source": "Aucune source fraîche raccordée",
    "context.reason.edf_collector_not_connected": "Collecteur du signal EDF non raccordé",
    "context.reason.irve_source_not_connected": "Source IRVE non raccordée",
    "progress.title": "Registre collectif",
    "progress.summary": "{count} présence(s) déclarée(s) sur {places} lieu(x) · {window}",
    "progress.empty": "Pas encore de présence déclarée · {window}",
    "progress.note":
      "Ce compteur décrit des déclarations agrégées, pas un nombre de personnes identifiées.",
    "class.municipality": "commune",
    "class.poi": "point d'intérêt",
    "class.area": "zone",
    "disclaimer.banner":
      "Présences contribuées volontairement — pas une estimation démographique représentative.",
    "flash.partialLoad": "Chargement partiel: {error}",
    "flash.published": "Présence publiée en agrégat.",
    "flash.revoked": "Vos présences actives ont été révoquées.",
    "flash.failed": "échec",
    "footer.blurb":
      "Service d'intérêt général — pas de publicité comportementale, pas de profils type Tinder en V0. Agent conversationnel: John.",
    "footer.publisher":
      "Éditeur : Association C.O.R.S.I.C.A. · Site public : oleole.acorsica.org · Agent : John (façade du Twin JHN)",
    "footer.publisher.facet":
      "Vous êtes sur oleole.jhn.baronsmariani.org (facette Twin). Site public et éditeur : oleole.acorsica.org — Association C.O.R.S.I.C.A.",
    "lang.aria": "Langue",
    "lang.fr": "FR",
    "lang.en": "EN",
    "panel.declareTitle": "Déclarer une présence",
    "panel.declareHint":
      "Visible uniquement en agrégat — pas de position individuelle précise par défaut.",
    "panel.place": "Lieu",
    "panel.choose": "Choisir…",
    "panel.poiSuffix": " (POI)",
    "panel.type": "Type",
    "panel.modality.declared": "Présence actuelle",
    "panel.modality.intended": "Présence future / intention",
    "panel.precision": "Précision",
    "panel.precision.municipality": "Commune",
    "panel.precision.area": "Zone approximative",
    "panel.precision.poi": "Point d'intérêt",
    "panel.validUntil": "Valide jusqu'à (optionnel)",
    "panel.intentLegend": "Intention (optionnel, agrégat)",
    "panel.intent.discovery": "Découverte",
    "panel.intent.social": "Social",
    "panel.intent.oleole": "Olé olé",
    "panel.oleoleNote":
      "« Olé olé » n'est pas un consentement à un contact. Aucun profil individuel n'est exposé.",
    "panel.publish": "Publier",
    "panel.revoke": "Révoquer mes présences",
    "info.title": "À propos d'Olé Olé",
    "info.intro":
      "Olé Olé est une carte de présences volontaires en Corse, produite par C.O.R.S.I.C.A. avec John.",
    "info.privacy":
      "Les présences sont publiques uniquement sous forme agrégée. Aucune position individuelle précise ni profil de rencontre n'est exposé.",
    "info.status":
      "Version exploratoire : les contributions sont utiles, mais ne constituent pas une mesure représentative de la population.",
    "invite.title": "Inviter sans traçage",
    "invite.intro":
      "Partagez Olé Olé avec des personnes qui pourraient contribuer à la carte. Aucun compte, carnet d’adresses ou suivi d’invitation n’est utilisé.",
    "invite.action": "Inviter / partager",
    "invite.text": "Rejoins la carte de présences volontaires Olé Olé en Corse.",
    "invite.qrAlt": "QR code vers Olé Olé",
    "invite.note": "Le QR code et le lien pointent vers le site public C.O.R.S.I.C.A.",
    "invite.copied": "Lien d’invitation copié.",
    "invite.copyFailed": "Copie impossible : utilisez le QR code ou l’adresse du site.",
    "install.title": "Sur votre téléphone",
    "install.intro":
      "Olé Olé peut s’installer comme application web, sans compte ni boutique d’applications.",
    "install.action": "Installer Olé Olé",
    "install.helpAction": "Comment installer",
    "install.help":
      "Dans le menu de votre navigateur, choisissez « Ajouter à l’écran d’accueil » ou « Installer l’application ».",
    "install.accepted":
      "Installation demandée. Vous pourrez ouvrir Olé Olé depuis votre écran d’accueil.",
    "install.installed": "Olé Olé est installé sur cet appareil.",
    "update.title": "Mise à jour disponible",
    "update.intro":
      "Une nouvelle version d’Olé Olé est prête. Elle ne sera activée qu’après votre accord ; vos réglages de contribution restent sous votre contrôle.",
    "update.apply": "Mettre à jour maintenant",
    "update.later": "Plus tard",
    "legal.title": "Éditeur, données et documents",
    "legal.legalTitle": "Mentions légales",
    "legal.termsTitle": "Conditions d’utilisation",
    "legal.privacyTitle": "Politique de confidentialité",
    "legal.back": "Retour à Olé Olé",
    "legal.editor":
      "Éditeur du service : Association C.O.R.S.I.C.A. (Corse Organisant la Réunion Sur Internet de Compétences Autonomes), association de droit français — SIREN 840 998 520. Adresse publiée : 1 cours Paoli, 20250 Corte. Direction de la publication : Jean Hugues Noël Robert.",
    "legal.data":
      "Les présences publiques sont limitées à des agrégats. Les données de présence peuvent être révoquées depuis ce service. Pour toute question sur vos données : jean_hugues_robert@yahoo.com.",
    "legal.host":
      "Hébergement : Netlify. Le code et les documents de gouvernance publics restent consultables dans les liens ci-dessous.",
    "legal.terms":
      "Conditions d’utilisation : le service est expérimental ; les indicateurs décrivent des contributions volontaires et ne constituent ni une estimation démographique ni une promesse de contact.",
    "legal.termsDetail":
      "Vous vous engagez à ne pas utiliser le service pour identifier, suivre, harceler ou contacter une personne à partir d’une présence agrégée.",
    "legal.privacy":
      "Confidentialité : pas de publicité comportementale, pas de profils individuels exposés, pas de traçage des invitations.",
    "legal.association": "Site public de l’association C.O.R.S.I.C.A.",
    "legal.governance": "Documents de gouvernance et de référence",
    "mode.title": "Mode de contribution",
    "mode.manual": "Manuel",
    "mode.auto": "Automatique",
    "mode.off": "Arrêt",
    "mode.pause": "Pause immédiate",
    "mode.hint":
      "Auto: changement significatif local → claim sémantique (commune), pas de journal GPS serveur continu. Précision courante: {precision}.",
    "mode.geoUnavailable": "Géolocalisation indisponible sur cet appareil.",
    "mode.autoActive": "Mode auto actif — détection de changements significatifs (local).",
    "mode.autoPublished": "Présence auto publiée: {place}",
    "mode.autoFailed": "Échec auto: {error}",
    "mode.geoError": "Géo: {error}",
    "mode.setAuto": "Mode automatique activé. Pause possible immédiatement.",
    "mode.setOff": "Mode arrêté — plus de publication automatique.",
    "mode.setManual": "Mode manuel.",
    "mode.paused": "Présence automatique en pause / révoquée côté politique locale.",
    "john.title": "John",
    "john.you": "Vous",
    "john.greeting":
      "Bonjour — je suis John, sur le service Olé Olé. Demandez « où ça bouge ce soir ? » ou déclarez une présence en langage naturel.",
    "john.placeholder": "Où ça bouge ce soir ?",
    "john.inputAria": "Message à John",
    "john.send": "Envoyer",
    "john.noReply": "Pas de réponse.",
    "john.networkError": "Erreur réseau: {error}",
    "nl.proposal": "Proposition : présence {modality} à {place} du {from} au {until}. Confirmer ?",
    "nl.placeUnknown":
      "Lieu non reconnu. Précisez une commune ou un lieu corse (ex. Corte, Calvi).",
    "nl.modality.declared": "actuelle",
    "nl.modality.intended": "future",
    "nl.modality.automatic": "automatique",
    "nl.modality.inferred": "inférée",
    "john.api.confirmed":
      "Présence enregistrée pour {place} (agrégat uniquement, pas d'exposition individuelle).",
    "john.api.failed": "Échec: {errors}",
    "john.api.emptyWindow":
      "Pour l'instant, peu de présences contribuées sur la fenêtre « {window} ». Les agrégats reflètent uniquement des déclarations volontaires — pas une estimation de population. Vous pouvez déclarer votre présence pour enrichir le champ.",
    "john.api.aggLine": "• {place}: {count} présence(s) déclarée(s)",
    "john.api.aggIntents": " (intentions agrégées: {list})",
    "john.api.aggHeader":
      "Voici les agrégats de présences contribuées ({window}) — données non représentatives:\n{lines}\n\nSouhaitez-vous un lieu plus calme, social, ou une déclaration de présence ?",
    "john.api.confirmHint": "\n\nPour confirmer: répondez « confirmer {place} »{future}.",
    "john.api.confirmFuture": " futur",
    "john.api.quiet":
      "Parmi les lieux ouverts, voici des pistes plus calmes d'après les contributions actuelles (indicatif):\n{lines}\n\nJe peux aussi enregistrer une présence future si vous le souhaitez.",
    "john.api.help":
      "Je suis John, agent du service Olé Olé (C.O.R.S.I.C.A.). Je m'appuie sur la même couche Presence/Place que la carte.\n\nExemples:\n• « Où ça bouge ce soir ? »\n• « Je suis à Corte jusqu'à 20h »\n• « Je serai à Calvi demain soir »\n• « Je cherche quelque chose de calme »\n\nLes présences publiques sont agrégées — pas de localisation individuelle précise par défaut.",
  },
  en: {
    "meta.title": "Olé Olé",
    "meta.description":
      "Olé Olé — territorial presence in Corsica. Public-interest service by C.O.R.S.I.C.A., agent John.",
    "brand.subtitle": "Territorial presence · C.O.R.S.I.C.A. · John",
    "proto.banner":
      "Early proto — exploratory build. Contributed data is not representative · no messaging · no dating-style profiles.",
    "proto.localMode": "local browser mode",
    "time.now": "Now",
    "time.tonight": "Tonight",
    "time.tomorrow": "Tomorrow",
    "time.aria": "Time window",
    "nav.contribute": "Contribute",
    "nav.mode": "Auto",
    "nav.john": "John",
    "nav.info": "About",
    "nav.panelsAria": "Panels",
    "map.aria": "Presence map",
    "map.presenceCount": "{count} declared presence(s)",
    "map.aggregateNote": "Contributed aggregate — not representative",
    "map.intents": "Intents (aggregate):",
    "map.intent.discovery": "discovery",
    "map.intent.social": "social",
    "map.intent.oleole": "olé olé",
    "map.noPresence": "No contributed presence in this window",
    "map.sources": "Sources: {list}",
    "context.title": "What’s happening here?",
    "context.chooseHint": "Choose a place or use your location for immediate context.",
    "context.useLocation": "Use my location",
    "context.choosePlace": "Choose a place",
    "context.choosePlaceholder": "Choose…",
    "context.privacy":
      "This request is temporary: it publishes no presence and your location is rounded before the query.",
    "context.loading": "Loading territorial context…",
    "context.unavailable": "Atmospheric context is unavailable for the moment.",
    "context.geoUnavailable": "Geolocation is unavailable on this device.",
    "context.geoDenied": "Location was not used. You can choose a place instead.",
    "context.outsideCorsica": "Olé Olé provides this context for Corsica only.",
    "context.nearYou": "Near you (approximate)",
    "context.atmosphere": "Atmosphere",
    "context.mobility": "Mobility",
    "context.energy": "Energy / EDF",
    "context.charging": "Charging / IRVE",
    "context.events": "Events",
    "context.unknown": "Unknown",
    "context.feelsLike": "Feels like {temp}°C · wind {wind} km/h",
    "context.reason.no_fresh_source": "No fresh source connected",
    "context.reason.edf_collector_not_connected": "EDF signal collector is not connected",
    "context.reason.irve_source_not_connected": "IRVE source is not connected",
    "progress.title": "Community register",
    "progress.summary": "{count} declared presence(s) across {places} place(s) · {window}",
    "progress.empty": "No declared presence yet · {window}",
    "progress.note": "This counts aggregate declarations, not identified people.",
    "class.municipality": "municipality",
    "class.poi": "point of interest",
    "class.area": "area",
    "disclaimer.banner":
      "Voluntarily contributed presences — not a representative population estimate.",
    "flash.partialLoad": "Partial load: {error}",
    "flash.published": "Presence published as aggregate.",
    "flash.revoked": "Your active presences have been revoked.",
    "flash.failed": "failed",
    "footer.blurb":
      "Public-interest service — no behavioural advertising, no Tinder-style profiles in V0. Conversational agent: John.",
    "footer.publisher":
      "Publisher: Association C.O.R.S.I.C.A. · Public site: oleole.acorsica.org · Agent: John (JHN Twin façade)",
    "footer.publisher.facet":
      "You are on oleole.jhn.baronsmariani.org (Twin facet). Public site & publisher: oleole.acorsica.org — Association C.O.R.S.I.C.A.",
    "lang.aria": "Language",
    "lang.fr": "FR",
    "lang.en": "EN",
    "panel.declareTitle": "Declare a presence",
    "panel.declareHint": "Visible only as aggregate — no precise individual location by default.",
    "panel.place": "Place",
    "panel.choose": "Choose…",
    "panel.poiSuffix": " (POI)",
    "panel.type": "Type",
    "panel.modality.declared": "Current presence",
    "panel.modality.intended": "Future presence / intention",
    "panel.precision": "Precision",
    "panel.precision.municipality": "Municipality",
    "panel.precision.area": "Approximate area",
    "panel.precision.poi": "Point of interest",
    "panel.validUntil": "Valid until (optional)",
    "panel.intentLegend": "Intent (optional, aggregate)",
    "panel.intent.discovery": "Discovery",
    "panel.intent.social": "Social",
    "panel.intent.oleole": "Olé olé",
    "panel.oleoleNote": "“Olé olé” is not consent to contact. No individual profile is exposed.",
    "panel.publish": "Publish",
    "panel.revoke": "Revoke my presences",
    "info.title": "About Olé Olé",
    "info.intro":
      "Olé Olé is a voluntary-presence map for Corsica, produced by C.O.R.S.I.C.A. with John.",
    "info.privacy":
      "Presences are public only as aggregates. No precise individual location or dating profile is exposed.",
    "info.status":
      "Exploratory build: contributions are useful, but not a representative population measure.",
    "invite.title": "Invite without tracking",
    "invite.intro":
      "Share Olé Olé with people who may contribute to the map. No account, address book, or invitation tracking is used.",
    "invite.action": "Invite / share",
    "invite.text": "Join Olé Olé, the voluntary presence map for Corsica.",
    "invite.qrAlt": "QR code for Olé Olé",
    "invite.note": "The QR code and link lead to the public C.O.R.S.I.C.A. site.",
    "invite.copied": "Invitation link copied.",
    "invite.copyFailed": "Could not copy the link: use the QR code or the site address.",
    "install.title": "On your phone",
    "install.intro": "Olé Olé can be installed as a web app, without an account or app store.",
    "install.action": "Install Olé Olé",
    "install.helpAction": "How to install",
    "install.help": "In your browser menu, choose “Add to Home Screen” or “Install app”.",
    "install.accepted": "Installation requested. You can open Olé Olé from your home screen.",
    "install.installed": "Olé Olé is installed on this device.",
    "update.title": "Update available",
    "update.intro":
      "A new Olé Olé version is ready. It will activate only after your approval; your contribution settings remain under your control.",
    "update.apply": "Update now",
    "update.later": "Later",
    "legal.title": "Publisher, data, and documents",
    "legal.legalTitle": "Legal notice",
    "legal.termsTitle": "Terms of use",
    "legal.privacyTitle": "Privacy policy",
    "legal.back": "Back to Olé Olé",
    "legal.editor":
      "Service publisher: Association C.O.R.S.I.C.A. (Corse Organisant la Réunion Sur Internet de Compétences Autonomes), an association under French law — SIREN 840 998 520. Published address: 1 cours Paoli, 20250 Corte. Publication director: Jean Hugues Noël Robert.",
    "legal.data":
      "Public presences are limited to aggregates. Presence data can be revoked from this service. For questions about your data: jean_hugues_robert@yahoo.com.",
    "legal.host":
      "Hosting: Netlify. The source code and public governance documents remain available through the links below.",
    "legal.terms":
      "Terms of use: the service is experimental; indicators describe voluntary contributions and are neither a population estimate nor a promise of contact.",
    "legal.termsDetail":
      "You agree not to use the service to identify, track, harass, or contact someone from an aggregate presence.",
    "legal.privacy":
      "Privacy: no behavioural advertising, no exposed individual profiles, and no invitation tracking.",
    "legal.association": "C.O.R.S.I.C.A. public website",
    "legal.governance": "Governance and reference documents",
    "mode.title": "Contribution mode",
    "mode.manual": "Manual",
    "mode.auto": "Automatic",
    "mode.off": "Off",
    "mode.pause": "Pause now",
    "mode.hint":
      "Auto: local significant change → semantic claim (municipality), no continuous server GPS log. Current precision: {precision}.",
    "mode.geoUnavailable": "Geolocation unavailable on this device.",
    "mode.autoActive": "Auto mode on — local significant-change detection.",
    "mode.autoPublished": "Auto presence published: {place}",
    "mode.autoFailed": "Auto failed: {error}",
    "mode.geoError": "Geo: {error}",
    "mode.setAuto": "Automatic mode enabled. You can pause immediately.",
    "mode.setOff": "Mode off — no further automatic publishing.",
    "mode.setManual": "Manual mode.",
    "mode.paused": "Automatic presence paused / revoked in local policy.",
    "john.title": "John",
    "john.you": "You",
    "john.greeting":
      "Hello — I’m John on the Olé Olé service. Ask “where’s lively tonight?” or declare a presence in natural language.",
    "john.placeholder": "Where’s lively tonight?",
    "john.inputAria": "Message to John",
    "john.send": "Send",
    "john.noReply": "No reply.",
    "john.networkError": "Network error: {error}",
    "nl.proposal": "Proposal: {modality} presence at {place} from {from} to {until}. Confirm?",
    "nl.placeUnknown": "Place not recognised. Name a Corsican town or place (e.g. Corte, Calvi).",
    "nl.modality.declared": "current",
    "nl.modality.intended": "future",
    "nl.modality.automatic": "automatic",
    "nl.modality.inferred": "inferred",
    "john.api.confirmed": "Presence recorded for {place} (aggregate only, no individual exposure).",
    "john.api.failed": "Failed: {errors}",
    "john.api.emptyWindow":
      "Few contributed presences so far for the “{window}” window. Aggregates only reflect voluntary declarations — not a population estimate. You can declare your presence to enrich the field.",
    "john.api.aggLine": "• {place}: {count} declared presence(s)",
    "john.api.aggIntents": " (aggregate intents: {list})",
    "john.api.aggHeader":
      "Contributed presence aggregates ({window}) — non-representative data:\n{lines}\n\nWould you like somewhere quieter, more social, or to declare a presence?",
    "john.api.confirmHint": "\n\nTo confirm: reply “confirm {place}”{future}.",
    "john.api.confirmFuture": " future",
    "john.api.quiet":
      "Among open places, quieter leads from current contributions (indicative):\n{lines}\n\nI can also record a future presence if you like.",
    "john.api.help":
      "I’m John, agent for the Olé Olé service (C.O.R.S.I.C.A.). I use the same Presence/Place layer as the map.\n\nExamples:\n• “Where’s lively tonight?”\n• “I’m in Corte until 8pm”\n• “I’ll be in Calvi tomorrow evening”\n• “I’m looking for somewhere quiet”\n\nPublic presences are aggregated — no precise individual location by default.",
  },
};
